import React from 'react'

import ModalFormBuilder from 'Skelet/src/components/ModalFormBuilder.js'

import config from '../config.js'


export default class extends React.Component {

  render() {
    let now = new Date();
    let date = now.getFullYear()+"-"+('0'+(now.getMonth()+1)).slice(-2)+"-"+('0'+now.getDate()).slice(-2);

    return <ModalFormBuilder
      config = {config}
      shouldShow = {this.props.shouldShow}
      close = {this.props.close}
      fields = {[{type:"date", dbcol:"date", placeholder:"datum", maxLength:"10"},
        {type:"textarea", dbcol:"text", placeholder:"tekst", maxLength:"600", rows:7}]}
      validate_fields = {[{dbcol:"date", name:"datum"}, {dbcol:"text", name:"tekst"}]}
      lettercounter="1"
      content={{date}}
      api_method = "POST"
      api_endpoint = "/diary"
      api_block = "diary_create"
      api_block_clear = "diary_list"
      success_alert = "false"
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/ModalCreateDiary.js